import styledComponents from "styled-components";
import Colors from "../Colors/ColorScheme";
import Fonts from "../Customs/Fonts";
import Size from "../Customs/Size";
import Resource from "../Resources/Resource";

export const Flex_Con = styledComponents.div`
    display:flex;
    color:${(props) => (props.color ? props.color : "white")};
    width:${(props) => props.width};
    size:${(props) => props.size};
    height:${(props) => props.height};

    @media (max-width:900px){
        flex-wrap:${(prop) => (prop.MFlexW != null ? "wrap-reverse" : "wrap")};
        gap:50px;
    }
`;

export const HeaderText = styledComponents.h1`
    margin:0;
    ${Fonts.poppins};
    letter-spacing:${Size.homePage.letterSpacing}px;
    font-size:${(props) => props.size};
    white-space: nowrap;
    
    @media (max-width:1200px){
        letter-spacing:2px;
        font-size:${Size.homePg_Media.xpass};
    }
`;
export const HeaderTextLighter = styledComponents.h2`
    ${(props) => (props.font == null ? Fonts.poppins : props.font)};
    margin:0;
    font-weight:${(props) => props.weight};
    font-size:${(props) => props.size};
`;

export const DescriptionText = styledComponents.p`
    ${Fonts.poppins};
    font-size:${(props) => props.size};
`;
export const Card_img = styledComponents.img`
    src:${(props) => props.src};
    width:100%;
    max-width:${(props) => props.maxW};
    min-width:${(props) => (props.minW == null ? "50%" : props.minW)};
`;
export const Block = styledComponents.div`
    height:${(props) => props.height};
    min-width:${(props) => props.minW};
    max-width:${(props) => props.maxW};
    width:${(props) => props.width};
    display:${(props) => props.display};
    align-content:${(props) => props.alignC};
    justify-content:${(props) => props.justifyC};
    align-items:${(props) => props.alignI};
    justify-items:${(props) => props.justifyI};
    padding:${(props) => props.pad};
    margin:0 auto;
    @media (max-width:700px){
        padding:${(props) => (props.Mpadd != null ? 0 : props.Mpadd)};
    }
`;
export const Floating_Div = styledComponents.div`
animation-name:floating;
animation-iteration-count: infinite;
animation-duration:8s;
animation-timing-function: ease-in-out;
@keyframes floating {
    0% { transform: translate(0,  0px); transform:rotate(0deg); }
    50%  { transform: translate(0, 12px); transform:rotate(5deg); }
    100%   { transform: translate(0, -0px); transform:rotate(0deg); }   
}
min-width:${(props) => props.minW};
`;

export const Dynamic_Margin = styledComponents.div`
    display:${(props) => (props.display == null ? "block" : props.display)};
    margin:${(props) => (props.margin == null ? "10px 10px" : props.margin)};
`;

export const GuideText = styledComponents.p`
    padding:0 0 0 5px;
    ${Fonts.poppins};
    margin:0;
    padding:0;
    font-weight:600;
    color:#8E989C;
`;
export const InputField = styledComponents.input`
    all:unset;
    font-weight:500;
    ${Fonts.poppins};
    background-color:${Colors.input.Form};
    color:${Colors.input.Fonts};
    padding:${Size.inputSize.padding};
    border-radius:${Size.inputSize.radius};
    width:250px;
    margin:5px 0;
`;



export const Button = styledComponents.a`
all:unset;
font-weight:500;
${Fonts.poppins};
background-color:${Colors.Button.background};
color:${Colors.Button.color};
padding:${Size.inputSize.padding};
border-radius:${Size.inputSize.radius};
opacity:0.8;
margin:5px 0;

&:hover{
    cursor:pointer;
    opacity:1;
}
`;
export const Outter_Section = styledComponents.section`
    background:white;
`;

export const Inner_Section = styledComponents.div`
    max-width:1100px;
    padding:100px 0;
    margin:0 auto;
    text-align:center;
    color:${(props) => (props.color == null ? "white" : props.color)};

    @media (max-width:700px){
        padding:70px 0px;
    }
`;

export const SimpleBoldText = styledComponents.h1`
    margin:0;
    ${Fonts.poppins};
    font-size:${props=>props.fs!=null?props.fs:"62px"};
    word-break:break-word;
    color:${arg=>arg.col!=null?arg.col:"black"}
    @media (max-width:1200px){
        font-size:52px;
    }

    @media (max-width:700px){
        font-size:42px;
    }

`;

export const Flex_Box = styledComponents.div`
display:flex;
gap:20px;
color:black;
align-items:center;
margin:0 auto;

@media (max-width:700px){
    flex-wrap:wrap;
    gap:0px;
}
`;

export const Border_box = styledComponents.div`
border: 1px solid #C6C6C6;
height:40px;
@media (max-width:700p){
    border:none;
}
`;
export const FadeOutBox = styledComponents.div`
    animation: fadeInOut 1s linear 1 forwards;
    zIndex: 10;
    animation-delay:2s;
  
  @keyframes fadeInOut {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 0;
    }
  }
`;

export const ErrorText = styledComponents.p`
padding:0 3px;
margin:2px;
font-size:12px;
${Fonts.poppins};
word-break:break-word;
color:red;

`;
export const Cursor_div = styledComponents.div`
  
&:hover{
    cursor:pointer;
}

`
export const SocialButton = styledComponents.div`
background-color: whitesmoke;
border-radius: 7px;
padding: 0 20px;
margin:5px 0;
  
&:hover{
    cursor:pointer;
}
`
export const C = styledComponents.span`
    color:${arg=>arg.col!=null?arg.col:"black"}
`